<ul class="flex flex-1">
  <slot />
</ul>
